import React from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom'
import { Container, Grid, Paper, Typography, Button, Box, Hidden  } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles'

import { useDispatch, useSelector } from 'react-redux';
import {
    setIgonFlag,
    clearIgonFlag,
} from '../stores/igon'

import GuideHead from './GuideHead' // ガイド
import GuideFoot from './GuideFoot' // ガイド

const drawerWidth = '20%';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: '350px',
        padding: '0',
        margin: 'auto',
        fontSize: '62.5%'
    },
    grid_wrap: {
        height: '50vh',
        marginBottom: '5rem'
    },
    grid: {
        width: '100%',
        height: '300px'
    },
    grid_item: {
        margin: '5px',
        marginBottom: '50px',
    },
    btn: {
        width: '100%',
    },
    txt: {
        padding: '10px'
    },
    underline: {
        textDecoration: 'underline',
        textDecorationColor: '#ff0000'
    },
    sub: {
        fontSize: '18px',
        color: '#88BA60',
        fontWeight: 'bold'
    },
    titleDecoration: {
        width: '100%',
    },
    navigation: {
        borderRadius: '10px 10px 10px 10px',
        backgroundColor: '#88BA60',
        color: 'white',
        marginTop: '50px',
        marginRight: '5px',
        padding: '5px'
    },
    navigationBox: {
        width: '260px',
        margin: '0 auto'
    },
    icon: {
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: '5px',
        border: '2px solid #fff',
        fontSize: '1.3em',
        fontWeight: 'bold',
        margin: '0 5px'
    },
    buttonIcon: {
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: '5px',
        border: '2px solid #fff',
        fontSize: '1.3em',
        fontWeight: 'bold',
        margin: '0 10px 0 -22px',
    }
}));


function Top(){
    const classes = useStyles();

    const dispatch = useDispatch();

    const history = useHistory();

    const testament = useSelector(state => state.testament);

    const handleSetIgonFlag = (event) => {

        dispatch(setIgonFlag(true));

        history.push('/author');
    }

    const handleClearIgonFlag = (event) => {

        dispatch(clearIgonFlag(false));

        history.push('/authorwill');
    }

    return (
        <Container maxWidth="sm" className={classes.root}>
            <Box className={classes.titleDecoration}>
                <img src="img/logo.jpg" />
            </Box>

            <GuideHead/>

            <Box className={classes.navigation}>
                <Box className={classes.navigationBox}>
                    <Typography align="justify">
                        自筆証書遺言を作成される方は、<br/>
                        <span className={classes.icon}>A</span>をクリック、<br />
                        財産目録を作成される方は<br/>
                        <span className={classes.icon}>B</span>をクリックしてください。
                    </Typography>
                </Box>
            </Box>
            <Grid container direction="column" justify="center" alignItems="center" className={classes.grid_wrap} spacing={5}>
                <Grid item className={classes.grid}>
                    <Grid item className={classes.grid_item}>
                        <Button variant="contained" color="primary" className={classes.btn} onClick={handleSetIgonFlag}><span className={classes.icon}>A</span>&nbsp;無料で自筆証書遺言を開始する</Button>
                    </Grid>
                    <Grid item className={classes.grid_item}>
                        <Button variant="contained" color="primary" className={classes.btn} onClick={handleClearIgonFlag}><span className={classes.buttonIcon}>B</span>&nbsp;無料で財産目録を開始する</Button>
                    </Grid>
                    <Grid item className={classes.grid_item}>
                        <Paper>
                            <Typography className={classes.txt}>
                                ご入力前に、<span className={classes.underline}>預金通帳</span>、<span className={classes.underline}>固定資産税通知書</span>ないし<span className={classes.underline}>不動産登記簿謄本、国債</span>、・<span className={classes.underline}>株式</span>、・<span className={classes.underline}>社債</span>などに関する<br />金融機関発行の<span className={classes.underline}>証明書</span>、<span className={classes.underline}>保険証書</span>などをお手元にご用意ください。
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>
            </Grid>

            <GuideFoot/>

        </Container>
    );
}

export default Top
